export const ICONS = {
  STAR: "Star",
  COIN: "Coin",
  HEART: "Heart",
  RAY: "Ray",
};
